import React from 'react'
import Title from '../../title/title.jsx'

const Hemsirelik = () => {
  return (
     <div>
    <Title text="Hemşirelik" align="left" size="m" />
    <p>Almanya’daki birçok Üniversite Hastaneleri başta olmak üzere her noktasında onlarca anlaşmalı hastanelerimizde sağlık sektöründe çalışmak isteyen, eğitimli ve deneyimli profesyonellere iş fırsatları sunuyoruz. Sağlık Meslek Lisesi veya ilgili lisans programlarından mezun olmuş, maksimum 45 yaşında, Almanca bilgisini kanıtlamış adayları Almanya’da güvenilir bir kariyer yolculuğuna davet ediyoruz. Konaklama, yerleşim ve entegrasyon süreçlerinde de çalışanlarımıza ücretsiz tam destek sağlanmaktadır.</p>

    <Title text="Açık Pozisyonlar" align="left" size="s" />
    <p><strong>•</strong> Hemşire</p>
    <p><strong>•</strong> Fizyoterapist</p>
    
    <Title text="Aranan Özellikler" align="left" size="s" />
    <p><strong>Eğitim: </strong>Sağlık Meslek Lisesi veya sağlık alanında dört yıllık lisans mezunu olmak.</p>
    <p><strong>Deneyim: </strong>Sağlık sektöründe minimum 8 aylık iş deneyimi.</p>
    <p><strong>Dil Bilgisi: </strong>En az B1 seviyesinde Almanca bilgisi. Başlangıç seviyesinde olanlar, Almanya’ya gitmeden önce B1 veya B2 seviyesine ulaşmak üzere dil eğitimini tamamlamalıdır.</p>
    <p><strong>Yaş: </strong>Maksimum 45 yaşında olabilir.</p>

    <Title text="Size Sağladığımız Avantajlar" align="left" size="s" />
    <p><strong>Hızlı Başvuru Süreci: </strong>Başvurularınız 81a kanun gereğince öncelikli olarak işleme alınır ve bekleme süreleri en aza indirilir. Almanya Federal Hükümeti, en fazla 16 haftada mesleki denkliği ve vize sürecini tamamlamaktadır. Üstelik, mesleki denklik ve vize ücretiniz olan 411 Euro tamamen işvereniniz tarafından karşılanır.</p>
    <p><strong>Masrafların Karşılanması: </strong>Evrak onaylama ve tercüme masraflarınız işe başladıktan sonra size geri ödenir. Almanya’ya seyahat ederken uçak biletiniz işvereniniz tarafından sağlanır.</p>
    <p><strong>Danışmanlık ve Destek Hizmetleri: </strong>Almanya’daki kurumlarla iletişim, vize işlemleri, aile birleşimi, konaklama gibi tüm aşamalarda danışmanlık hizmetlerimiz tamamen ücretsizdir.</p>
  </div>
  )
}

export default Hemsirelik